module.exports = __webpack_public_path__ + "img/image2.cdfda53e.png";